import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export const trackEvent = (type) => {
    api.post("/analytics/event", { type }).catch(() => {});
};
